export var FCloudDataType;
(function (FCloudDataType) {
    FCloudDataType[FCloudDataType["Int32"] = 1] = "Int32";
    FCloudDataType[FCloudDataType["Float"] = 2] = "Float";
    FCloudDataType[FCloudDataType["Bool"] = 4] = "Bool";
    FCloudDataType[FCloudDataType["String"] = 8] = "String";
    FCloudDataType[FCloudDataType["Binary"] = 90] = "Binary";
    FCloudDataType[FCloudDataType["Hex"] = 99] = "Hex";
})(FCloudDataType || (FCloudDataType = {}));
